<template>
  <card headerTitle="Публичная оферта" hideFooter hideReload>
    <template slot="block">
      <div v-html="offerHTML"></div>
    </template>
  </card>
</template>
<script>
import card from "@/components/card.vue";
import HTTP from "@/utils/http.js";
export default {
  name: "Offer",
  components: { card },
  data() {
    return {
      offer: null,
    };
  },
  computed:{
    offerHTML(){
      return this.offer;
    }
  },
  created() {
    HTTP({ url: "../static/offer.html" })
      .then((resp) => {
        this.offer = resp.data;
      })
      .catch();
  },
};
</script>